
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const useOwnerCurrency = () => {
  return useQuery({
    queryKey: ["ownerCurrency"],
    queryFn: async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) throw new Error("Non authentifié");

      // On vérifie d'abord dans owner_data
      const { data: ownerData, error: ownerError } = await supabase
        .from("owner_data")
        .select("currency")
        .eq("owner_id", user.id)
        .single();

      if (ownerError) {
        console.error("Erreur lors de la récupération de owner_data:", ownerError);
        throw ownerError;
      }

      // Si on trouve la devise dans owner_data et qu'elle n'est pas null, on l'utilise
      if (ownerData?.currency) {
        // On utilise directement le code de la devise plutôt que son symbole
        return ownerData.currency;
      }

      // Si aucune devise n'est trouvée dans owner_data ou si elle est null
      // On vérifie les métadonnées de l'utilisateur
      const userCurrency = user.user_metadata?.currency;
      console.log("Devise des métadonnées utilisateur:", userCurrency);
      
      if (userCurrency) {
        return userCurrency;
      }

      // Si toujours rien trouvé, on utilise GNF par défaut
      console.log("Aucune devise trouvée, utilisation de GNF par défaut");
      return "GNF";
    },
    staleTime: 1000 * 60 * 5, // Cache pendant 5 minutes
  });
};
